export default __webpack_public_path__ + "static/media/financas5.3a5131ea.jpg";